import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import TutorSidebar from '../../../TutorSidebar/TutorSidebar'
import { getTutorViewAssListData } from '../../../../../Redux/action/TutorAction';
import Beatloader from '../../../../../Common/BeatLoader';
import ResponsivePagination from '../../../../../Common/Pagination';

const TutorViewAddedAssessment = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getTutorViewAssListData({}))
    }, []);

    const {

        loadingTutorViewAssListApi,
        TutorViewAssListApiData,
        TutorViewAssListApiError

    } = useSelector(state => state?.TutorReducer);

    //pagination
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1); // ✅ 1-based page index
    const dataPerPage = 10;

    useEffect(() => {
        if (!TutorViewAssListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(TutorViewAssListApiData.slice(start, end));
        setPageCount(Math.ceil(TutorViewAssListApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, TutorViewAssListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };


    return (
        <div className='pagination-component'>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;View Assessment Course
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <h4 className="mb-3">View Assessment Course</h4>
                                {loadingTutorViewAssListApi ?
                                    <Beatloader />
                                    :
                                    <div className="row">
                                        {TutorViewAssListApiData?.length ?
                                            currentData?.map((data) => (
                                                <div className="col-lg-6 mb-2">
                                                    <Link
                                                        to={`/tutor/${data?.question_type ? 'view-assessment-subjective-test' : 'view-assessment-objective-test'}/${btoa(data?.id)}`}
                                                        className="text-black text-decoration-none"
                                                    >
                                                        <div className="card">
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-lg-6">
                                                                        <h6 className="text-primary mb-0">Course Name : {data?.course?.name}</h6>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <div className="d-flex gap-2 text-end justify-content-end">
                                                                            <span className="badge bg-primary text-white text-end">
                                                                                {data?.question_type ? 'Subjective' : 'Objective'}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-lg-8">
                                                                        <h6 className="mb-0 text-dark">Assessment Name : {data?.assesment_name}</h6>
                                                                    </div>
                                                                    <div className="col-lg-4">
                                                                        <p className="text-end mb-0 text-dark">
                                                                            <i>{data?.approval_status}</i>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-lg-5 pe-0">
                                                                        <p className="mb-0 text-dark" style={{ fontSize: 13 }}>
                                                                            created at : {data?.createdAt ? new Date(data?.createdAt).toDateString() : ''}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-lg-3 pe-0">
                                                                        <p className="mb-0 text-dark" style={{ fontSize: 13 }}>
                                                                            Total marks : {data?.total_marks}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-lg-4">
                                                                        <p className="mb-0 text-end text-dark" style={{ fontSize: 13 }}>
                                                                            Duration {data?.duration} min
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            ))
                                            :
                                            <div className='no-data-img'>
                                                <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                            </div>

                                        }
                                        {pageCount > 1 && (
                                            <ResponsivePagination
                                                pageCount={pageCount}
                                                currentPage={currentPage}
                                                handlePageClick={handlePageClick}
                                            />
                                        )}

                                    </div>}
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorViewAddedAssessment